import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { adminLogin } from '../../services/api';
import { Mountain, Eye, EyeOff } from 'lucide-react';

const AdminLogin = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminLogin({ username, password });
      login(res.data.token, res.data.username);
    } catch (err) {
      setError(err.response?.data?.detail || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f9f9f6] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#3D4A26] rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Mountain size={32} className="text-[#C8D843]" />
          </div>
          <h1 className="text-2xl font-bold text-[#1B1B1B]" style={{ fontFamily: 'DM Sans, sans-serif' }}>Camption Admin</h1>
          <p className="text-sm text-gray-500 mt-1">Yönetim paneline giriş yapın</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 space-y-5">
          {error && <div className="bg-red-50 text-red-600 text-sm px-4 py-3 rounded-lg">{error}</div>}

          <div>
            <label className="block text-sm font-semibold text-[#1B1B1B] mb-1.5">Kullanıcı Adı</label>
            <input
              type="text" value={username} onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-gray-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#C8D843] focus:border-transparent"
              placeholder="admin" required
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-[#1B1B1B] mb-1.5">Şifre</label>
            <div className="relative">
              <input
                type={showPw ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-4 py-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-[#C8D843] focus:border-transparent"
                placeholder="••••••••" required
              />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <button
            type="submit" disabled={loading}
            className="w-full bg-[#3D4A26] text-white font-bold py-3 rounded-lg hover:bg-[#2d3a1a] transition-colors disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
